import { getIconPath } from "@genexus/mercury";

export const ALL_VALUE = "All";
export const ALL_MODULES = "All Modules";
export const ALL_TYPES = "All Types";

export const CSS_SELECTORS = {
  HEADER: "header spacing-body-inline spacing-body-block-start",
  HEADER_DETAILS: "header__details",
  FILTER: "filter",
  MAIN: "main spacing-body",
  GRID_CELL_DESCRIPTION: "tabular-grid-cell-description-custom-selector"
};

const ICONS = {
  add: getIconPath({
    category: "system",
    name: "add",
    colorType: "on-surface"
  }),
  edit: getIconPath({
    category: "system",
    name: "edit",
    colorType: "on-surface"
  }),
  error: getIconPath({
    category: "system",
    name: "error",
    colorType: "error"
  }),
  filter: getIconPath({
    category: "window-tools",
    name: "filter",
    colorType: "interactive"
  }),
  filterWithConditions: getIconPath({
    category: "window-tools",
    name: "filter-conditions",
    colorType: "interactive"
  }),
  info: getIconPath({
    category: "system",
    name: "information",
    colorType: "on-surface"
  }),
  refresh: getIconPath({
    category: "gemini-tools",
    name: "reset",
    colorType: "interactive"
  }),
  search: getIconPath({
    category: "system",
    name: "search",
    colorType: "on-surface"
  }),
  success: getIconPath({
    category: "system",
    name: "check",
    colorType: "success"
  }),
  substract: getIconPath({
    category: "system",
    name: "substract",
    colorType: "on-surface"
  }),
  warning: getIconPath({
    category: "system",
    name: "warning",
    colorType: "warning"
  })
};
export default ICONS;
